export const EcommerceChangesTrend = {
    Grew: "grew",
    Declined: "declined",
} as const;

export type EcommerceChangesTrend = (typeof EcommerceChangesTrend)[keyof typeof EcommerceChangesTrend];

export default EcommerceChangesTrend;
